import { ProductCategoryEntity, ProductEntity } from 'src/modules/products';
import { FilterMenuItem } from 'src/modules/form/field/filters/types';

export enum SearchActions {
  FetchSearchDataBegin = 'SEARCH/FETCH/BEGIN',
  FetchSearchDataSuccess = 'SEARCH/FETCH/SUCCESS',
  FetchSearchDataError = 'SEARCH/FETCH/ERROR',
  FetchSearchSuggestionsDataBegin = 'SEARCH_SUGGESTIONS/FETCH/BEGIN',
  FetchSearchSuggestionsDataSuccess = 'SEARCH_SUGGESTIONS/FETCH/SUCCESS',
  FetchSearchSuggestionsDataError = 'SEARCH_SUGGESTIONS/FETCH/ERROR',
  FetchTopSearchedProductsBegin = 'SEARCH_TOP_PRODUCTS/FETCH/BEGIN',
  FetchTopSearchedProductsSuccess = 'SEARCH_TOP_PRODUCTS/FETCH/SUCCESS',
  FetchTopSearchedProductsError = 'SEARCH_TOP_PRODUCTS/FETCH/ERROR',
  FetchTopSearchedProductCategoriesBegin = 'SEARCH_TOP_PRODUCT_CATEGORIES/FETCH/BEGIN',
  FetchTopSearchedProductCategoriesSuccess = 'SEARCH_TOP_PRODUCT_CATEGORIES/FETCH/SUCCESS',
  FetchTopSearchedProductCategoriesError = 'SEARCH_TOP_PRODUCT_CATEGORIES/FETCH/ERROR',
  FetchSearchFilterDataBegin = 'SEARCH_FILTER_DATA/FETCH/BEGIN',
  FetchSearchFilterDataSuccess = 'SEARCH_FILTER_DATA/FETCH/SUCCESS',
  FetchSearchFilterDataError = 'SEARCH_FILTER_DATA/FETCH/ERROR',
  SetFilters = 'SEARCH_FILTERS/SET',
}

export interface SearchFilterData {
  productCategories: FilterMenuItem[];
  designers: FilterMenuItem[];
  locationTypes: FilterMenuItem[];
}

export interface SearchStore {
  isLoadedSuggestions: boolean;
  isLoadingSuggestions: boolean;
  suggestionsError: any;
  suggestions: ProductEntity[];
  results: ProductEntity[];
  count: number;
  offset: number;
  topSearchedProducts: ProductEntity[];
  topSearchedProductCategories: ProductCategoryEntity[];
  searchString: string;
  filters: SearchFilterData;
  filterData: SearchFilterData;
}
